@if (isReady) {
  @if (orders?.length) {
    <table class="table-depot" @onlyEnter aria-describedby="canceled">
      <tbody>
        <tr>
          <th>
            <web-components-sorter-label
              [sorter]="sorter"
              attr="assetName"
              label="mydepot.depotoverview.canceled-orders.labels.assetName"
              direction="after"
              (click)="sortBy('assetName')"
            /><br />
            <web-components-sorter-label
              [sorter]="sorter"
              attr="isin"
              label="mydepot.depotoverview.canceled-orders.labels.isin"
              direction="after"
              (click)="sortBy('isin')"
            />
          </th>
          <th>
            {{ 'mydepot.depotoverview.canceled-orders.labels.quantity' | transloco }}<br />
            {{ 'mydepot.depotoverview.canceled-orders.labels.status' | transloco }}
          </th>
          <th>
            {{ 'mydepot.depotoverview.canceled-orders.labels.execType' | transloco }}<br />
            {{ 'mydepot.depotoverview.canceled-orders.labels.stopLimit' | transloco }}
          </th>
          <th>
            <web-components-sorter-label
              [sorter]="sorter"
              attr="cancelDate"
              label="mydepot.depotoverview.canceled-orders.labels.cancelDate"
              direction="before"
              (click)="sortBy('cancelDate')"
            /><br />
            <web-components-sorter-label
              [sorter]="sorter"
              attr="validToDate"
              label="mydepot.depotoverview.canceled-orders.labels.validToDate"
              direction="before"
              (click)="sortBy('validToDate')"
            />
          </th>
          <th>
            <web-components-sorter-label
              [sorter]="sorter"
              attr="direction"
              label="mydepot.depotoverview.canceled-orders.labels.direction"
              direction="before"
              (click)="sortBy('direction')"
            /><br />
            {{ 'mydepot.depotoverview.canceled-orders.labels.value' | transloco }}
          </th>
          @if (actionsEnabled) {
            <th></th>
          }
        </tr>
        @for (order of orders | slice: 0 : pageSize; track order.id) {
          <tr app-canceled-order-item [order]="order" [actionsEnabled]="actionsEnabled"></tr>
        }
      </tbody>
    </table>
    <div class="row mt-2 mb-4">
      <div class="col-12 text-right">
        <a [class.hidden]="!hasNext" (click)="showMore()" class="link-secondary cursor-pointer">
          {{ 'mydepot.depotoverview.canceled-orders.more' | transloco }} <span class="sorter-after-flat sorter-after-flat--down"></span>
        </a>
      </div>
    </div>
  } @else {
    <p class="mt-3 mb-0">
      {{ 'mydepot.depotoverview.canceled-orders.empty' | transloco }}
    </p>
  }
  <ng-template #empty>
    <p class="mt-3 mb-0">
      {{ 'mydepot.depotoverview.canceled-orders.empty' | transloco }}
    </p>
  </ng-template>
}
